module.exports = __webpack_public_path__ + "static/media/oman.288b67ad.png";